import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './autocomplete_item.module.scss';

type Props = {
  className?: string;
  isSelected: boolean;
  hasOffset?: boolean;
  onClick: (event: React.MouseEvent<HTMLSpanElement>) => void;
};

export const AutocompleteItem: FC<Props> = (props) => {
  const { className, isSelected, hasOffset, ...rest } = props;
  return (
    <li
      className={classNames(styles.item, {
        [styles.selected]: isSelected,
        [styles.offset]: hasOffset,
      })}
      {...rest}
    />
  );
};
